import { GetNextRunData, getNextRun as getNextRunApi } from '../../openapi/index';

export const getNextRun = async (assayId: string) => {
  const data: GetNextRunData = {
    body: {
      assay_id: assayId,
    },
  };

  return (await getNextRunApi(data)).data;
};

export default getNextRun;
